import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loansSignUpResumeComponent from './loansSignUpResume.component';

let loansSignUpResumeModule = angular.module('loansSignUpResume', [
  uiRouter
])

.component('loansSignUpResume', loansSignUpResumeComponent)

.name;

export default loansSignUpResumeModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpResume/loansSignUpResume.js